export default {
	getData: function(id) {
		var selector = 'new' == id ? 'new_discussion_post' : 'discussion_post_' + id;
		return Grabcad.store[selector];
	},

	getDOMId: function(id) {
		return 'p' + id;
	},

	showPost: function (id) {
		var POST_SCROLL_OFFSET = -32;
		var targetHref = this.getData(id).url;
		var domHash = '#' + this.getDOMId(id);

		if (typeof Promise === 'undefined') return window.location.href = targetHref;

		var scrollSuccess = function scrollSuccess () {
			Grabcad.scrollService.highlightContent(domHash);
			Grabcad.scrollService.updateHash(domHash);
		};

		var scrollError = function scrollError (noTargetFound) {
			if (noTargetFound) window.location.href = targetHref;
		};

		Grabcad.scrollService
			.scrollToElement(domHash, POST_SCROLL_OFFSET)
			.then(scrollSuccess)
			.catch(scrollError);
	}
}
